export enum QuranTutorsRoutePath {
    Registration = '/quran-tutors/registration',
    Batch = '/quran-tutors/registration/batch/:idBatch',
    Verification = '/quran-tutors/registration/batch/:idBatch/verification/:id',
    InstructorRegistration = '/quran-tutors/instructor-registration',
    InstructorVerification = '/quran-tutors/instructor-registration/verification/:id',
    InstructorQuranMethod = '/quran-tutors/instructor-registration/quran-methods',
    List = '/quran-tutors/list',
    TutorDetail = '/quran-tutors/list/detail/:idTutor',
    TutorDetailProfile = '/quran-tutors/list/detail/:idTutor/profile',
    ValidateActivity = '/quran-tutors/validate-activity',
    ValidateActivityVerification = '/quran-tutors/validate-activity/verification/:id',
    ManualPresence = '/quran-tutors/validate-activity/manual-presence/:id',
    Incentive = '/quran-tutors/incentive',
    Disbursement = '/quran-tutors/disbursement',
    Report = '/quran-tutors/disbursement/report',
    ReportDetail = '/quran-tutors/disbursement/report/detail/:period'
}
